import { render, staticRenderFns } from "./AddAlertStep.vue?vue&type=template&id=9dfe9dd6&scoped=true&"
import script from "./AddAlertStep.vue?vue&type=script&lang=js&"
export * from "./AddAlertStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dfe9dd6",
  null
  
)

export default component.exports